module.exports = __webpack_public_path__ + "static/media/b15-和心园.ce5f3990.png";